/**
 * Created by lautaro on 04/01/17.
 */
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from "./component/login.component";
import {RegisterFormComponent} from "./register-form/register-form.component";

const loginRoutes: Routes = [
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'register',
        component: RegisterFormComponent
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(loginRoutes)
    ]
    /*),
    providers: [
      AuthGuard,
      LoginGuard
    ]*/,
    exports: [
        RouterModule
    ]
})
export class LoginRoutingModule {
}


// WEBPACK FOOTER //
// ./src/app/login/routing.module.ts